module.exports = __webpack_public_path__ + "static/media/flag.b17c15d4.png";